import type { Editor } from '@tiptap/react'
import { posToDOMRect } from '@tiptap/react'
import { computePosition } from '@floating-ui/dom'
import { shift, flip } from '@floating-ui/react'

export const updateTiptapSuggestionsPosition = (
  editor: Editor,
  element: HTMLElement,
) => {
  const virtualElement = {
    getBoundingClientRect: () =>
      posToDOMRect(
        editor.view,
        editor.state.selection.from,
        editor.state.selection.to,
      ),
  }

  computePosition(virtualElement, element, {
    placement: 'bottom-start',
    strategy: 'absolute',
    middleware: [shift(), flip()],
  }).then(({ x, y, strategy }) => {
    element.style.width = 'max-content'
    element.style.position = strategy
    element.style.left = `${x}px`
    element.style.top = `${y}px`
  })
}
